import { theme } from '@primer/react';
import * as React from 'react';
export default {
  theme,
  React
};